import { create } from "zustand";
import { persist, createJSONStorage, devtools } from "zustand/middleware";
import { createAuthSlice, AuthSlice } from "./authSlice";
import { createServerTimeSlice, ServerTimeSlice } from "./serverTimeSlice";
export type GlobalStore = AuthSlice & ServerTimeSlice;

export const createGlobalStore = () =>
  create<GlobalStore>()(
    devtools(
      persist(
        (...a) => ({
          ...createAuthSlice(...a),
          ...createServerTimeSlice(...a),
        }),
        {
          name: "global-store",
          storage: createJSONStorage(() => localStorage),
          partialize: (state) => ({
            memberId: state.memberId,
            accessToken: state.accessToken,
            serverTime: state.serverTime,
          }),
          onRehydrateStorage: () => (state) => {
            state?.setIsLoading(false);
          },
        },
      ),
    ),
  );

// Singleton store instance for imperative access
let globalStoreInstance: ReturnType<typeof createGlobalStore> | null = null;

export function getGlobalStoreInstance() {
  if (!globalStoreInstance) {
    globalStoreInstance = createGlobalStore();
  }
  return globalStoreInstance;
}

export function setGlobalStoreInstance(
  store: ReturnType<typeof createGlobalStore>,
) {
  globalStoreInstance = store;
}
